module.exports = __webpack_public_path__ + "static/media/id_badge.d1e8154a.svg";